/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { WebSiteStatusViewModelPrimeDatatableResults } from '../../models/web-site-status-view-model-prime-datatable-results';

export interface ListWebSiteStatuses$Params {
      body?: PrimeDatatableParams
}

export function ListWebSiteStatuses(http: HttpClient, rootUrl: string, params?: ListWebSiteStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListWebSiteStatuses.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebSiteStatusViewModelPrimeDatatableResults>;
    })
  );
}

ListWebSiteStatuses.PATH = '/api/Developer/ListWebSiteStatuses';
